import React, { useMemo } from "react";
import Typography from "../Typography";

import { ReactComponent as LoginSvg } from "../../build/images/login.svg";
import { createJSON } from "../../utils/createJSON";
import { isJson } from "../../utils/isJson";
import { Tooltippy } from "../../actions/Tippy";
import { ReactComponent as ArrowDown } from "../../build/images/arrow_down.svg";
import { connection_platform } from "../../services/api";
import { useSelector } from "react-redux";
import unicodeToChar from "../../actions/formatUnicode";
import { Building, ExportSquare, InfoCircle, Layer } from "iconsax-reactjs";
import ReactHtmlParser from "react-html-parser";
import { dbfileSize } from "../../actions";
import { useSideDetails } from "./hooks/useSideDetails";

import "./side-details.styles.css";
import { handleCopy, treateReasonToCopy } from "../../utils/handleCopy";
import { getDescription } from "../../utils/getDescription";
import { formatarNomeDoContato } from "../../actions/websocket";

const SideDetails = ({
  selectedChat,
  openDetails,
  setOpenDetails,
  detailsOptions,
  setDetailsOptions,
  DisplayHistoric,
  historyInfo,
  ShowModals,
  tratarUnderline,
  getMediaIcon,
  buttonSearchAnotation,
  buttonSearchMarkstar,
  buttonSearchFileCompart,
}) => {
  const {
    hasEnterpriseAdditionalInfos,
    hasContactAdditionalInfos,
    MenuBot,
    MenuBotContactInfos,
    MenuBotEnterprise,
    MenuBotInformations,
    InfoUsers,
    copyFeedback,
    showCopyFeedback,
  } = useSideDetails(selectedChat);

  return (
    selectedChat &&
    openDetails && (
      <div className="container-details side-details-new">
        <div className="details-line">
          <div className="details-line__header">
            <Typography.H4 weight={700} color={"blue-selected-4"}>
              Detalhes
            </Typography.H4>
            <LoginSvg
              className="close-details"
              onClick={() => {
                setOpenDetails(false);
              }}
            />
          </div>
        </div>
        <div className="details-line">
          <Typography.H4 weight={700} color={"blue-selected-4"}>
            {createJSON(formatarNomeDoContato(selectedChat.cliente))}
          </Typography.H4>
        </div>
        <div className="details-line details-line-new">
          <ul className="details__info-list details__info-list-new">
            <li className="details__info-item-container">
              <span className="details__info-title">
                <Layer color="#000000" />
                <Typography.H5 color={"black"} weight={700}>
                  Dados do contato
                </Typography.H5>
              </span>
              {selectedChat.idmidia !== "3" && (
                <li className="details__info-item">
                  {/* <span className="details__info-icon material-icons">
                      smartphone
                    </span> */}
                  <span className="details__info-label">Telefone:</span>
                  <span
                    className="details__info-text"
                    onClick={(e) => {
                      const isCopied = handleCopy(selectedChat.telefone);
                      if (isCopied) {
                        showCopyFeedback(e.clientX, e.clientY);
                      }
                    }}
                  >
                    {formatarNomeDoContato(selectedChat.telefone)}
                  </span>
                </li>
              )}
              <li className="details__info-item">
                {/* <span className="details__info-icon material-icons">
                    watch_later
                  </span> */}
                <span className="details__info-label">Data do contato: </span>
                <span
                  className="details__info-text"
                  onClick={(e) => {
                    const isCopied = handleCopy(selectedChat.datatimeatd);
                    if (isCopied) {
                      showCopyFeedback(e.clientX, e.clientY);
                    }
                  }}
                >
                  {selectedChat.datatimeatd}
                </span>
              </li>
              <li className="details__info-item">
                {/* <span className="details__info-icon material-icons">
                    contact_support
                  </span> */}
                <span className="details__info-label">Motivo: </span>
                <span
                  className="details__info-text"
                  onClick={(e) => {
                    const isCopied = handleCopy(
                      treateReasonToCopy(
                        parseInt(selectedChat.direction) === 1
                          ? selectedChat.nomesubservico
                          : selectedChat.servico
                      )
                    );
                    if (isCopied) {
                      showCopyFeedback(e.clientX, e.clientY);
                    }
                  }}
                >
                  {parseInt(selectedChat.direction) === 1
                    ? selectedChat.nomesubservico
                    : selectedChat.servico}
                </span>
              </li>
              {MenuBotContactInfos.map((bot, index) => {
                const separator = bot.split(":");
                const description = getDescription(separator);
                if (separator[0]) {
                  return (
                    <li key={index} className="details__info-item">
                      <span className="details__info-label">
                        {`${createJSON(separator[0])}: `}
                      </span>
                      {description ? (
                        description.length > 21 ? (
                          <Tooltippy
                            content={
                              description.length > 21
                                ? createJSON(description)
                                : ""
                            }
                          >
                            <span
                              className="details__info-text"
                              onClick={(e) => {
                                const isCopied = handleCopy(
                                  createJSON(description)
                                );
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {description.length > 21
                                ? `${createJSON(description).slice(0, 21)}
                                    ...`
                                : createJSON(description)}
                            </span>
                          </Tooltippy>
                        ) : (
                          <span
                            className="details__info-text"
                            onClick={(e) => {
                              const isCopied = handleCopy(
                                createJSON(description)
                              );
                              if (isCopied) {
                                showCopyFeedback(e.clientX, e.clientY);
                              }
                            }}
                          >
                            {createJSON(description)}
                          </span>
                        )
                      ) : (
                        ""
                      )}

                      {/* <span className="details__info-inner-text">12345</span> */}
                    </li>
                  );
                }
              })}
              {hasContactAdditionalInfos &&
                selectedChat.contactAdditionalInfos.map((bot, index) => {
                  const separator = bot.split(":");
                  const description = getDescription(separator);

                  if (separator[0]) {
                    return (
                      <li key={index} className="details__info-item">
                        <span className="details__info-label">
                          {`${createJSON(separator[0])}: `}
                        </span>
                        {description ? (
                          description.length > 21 ? (
                            <Tooltippy
                              content={
                                description.length > 21
                                  ? createJSON(description)
                                  : ""
                              }
                            >
                              <span
                                className="details__info-text"
                                onClick={(e) => {
                                  const isCopied = handleCopy(
                                    createJSON(description)
                                  );
                                  if (isCopied) {
                                    showCopyFeedback(e.clientX, e.clientY);
                                  }
                                }}
                              >
                                {description.length > 21
                                  ? `${createJSON(description).slice(0, 21)}
                                    ...`
                                  : createJSON(description)}
                              </span>
                            </Tooltippy>
                          ) : (
                            <span
                              className="details__info-text"
                              onClick={(e) => {
                                const isCopied = handleCopy(
                                  createJSON(description)
                                );
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {createJSON(description)}
                            </span>
                          )
                        ) : (
                          ""
                        )}

                        {/* <span className="details__info-inner-text">12345</span> */}
                      </li>
                    );
                  }
                })}
            </li>
            <ul>
              <li className="details__info-item-container">
                <span className="details__info-title">
                  <Building color="#000000" />
                  <Typography.H5 color={"black"} weight={700}>
                    Dados da empresa
                  </Typography.H5>
                </span>
                {MenuBotEnterprise.map((bot, index) => {
                  const separator = bot.split(":");
                  const description = getDescription(separator);

                  if (separator[0]) {
                    return (
                      <li key={index} className="details__info-item">
                        <span className="details__info-label">
                          {`${createJSON(separator[0])}: `}
                        </span>
                        {description ? (
                          description.length > 21 ? (
                            <Tooltippy
                              content={
                                description.length > 21
                                  ? createJSON(description)
                                  : ""
                              }
                            >
                              <span
                                className="details__info-text"
                                onClick={(e) => {
                                  const isCopied = handleCopy(
                                    createJSON(description)
                                  );
                                  if (isCopied) {
                                    showCopyFeedback(e.clientX, e.clientY);
                                  }
                                }}
                              >
                                {description.length > 21
                                  ? `${createJSON(description).slice(0, 21)}
                                    ...`
                                  : createJSON(description)}
                              </span>
                            </Tooltippy>
                          ) : (
                            <span
                              className="details__info-text"
                              onClick={(e) => {
                                const isCopied = handleCopy(
                                  createJSON(description)
                                );
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {createJSON(description)}
                            </span>
                          )
                        ) : (
                          ""
                        )}

                        {/* <span className="details__info-inner-text">12345</span> */}
                      </li>
                    );
                  }
                })}
                {hasEnterpriseAdditionalInfos &&
                  selectedChat.enterpriseAdditionalInfos.map((bot, index) => {
                    const separator = bot.split(":");
                    const description = getDescription(separator);
                    if (separator[0]) {
                      return (
                        <li key={index} className="details__info-item">
                          <span className="details__info-label">
                            {`${createJSON(separator[0])}: `}
                          </span>
                          {description ? (
                            description.length > 21 ? (
                              <Tooltippy
                                content={
                                  description.length > 21
                                    ? createJSON(description)
                                    : ""
                                }
                              >
                                <span
                                  className="details__info-text"
                                  onClick={(e) => {
                                    const isCopied = handleCopy(
                                      createJSON(description)
                                    );
                                    if (isCopied) {
                                      showCopyFeedback(e.clientX, e.clientY);
                                    }
                                  }}
                                >
                                  {description.length > 21
                                    ? `${createJSON(description).slice(0, 21)}
                                    ...`
                                    : createJSON(description)}
                                </span>
                              </Tooltippy>
                            ) : (
                              <span
                                className="details__info-text"
                                onClick={(e) => {
                                  const isCopied = handleCopy(
                                    createJSON(description)
                                  );
                                  if (isCopied) {
                                    showCopyFeedback(e.clientX, e.clientY);
                                  }
                                }}
                              >
                                {createJSON(description)}
                              </span>
                            )
                          ) : (
                            ""
                          )}

                          {/* <span className="details__info-inner-text">12345</span> */}
                        </li>
                      );
                    }
                  })}
              </li>
            </ul>
            <li className="details__info-item-container">
              <span className="details__info-title">
                <InfoCircle color="#000000" />
                <Typography.H5 color={"black"} weight={700}>
                  Informações
                </Typography.H5>
              </span>
              {/* {ContactId.idmidia !== "3" && ( */}
              <li className="details__info-item">
                {/* <span className="details__info-icon material-icons">
                      list
                    </span> */}
                {/* <span className="details__info-label">Informações</span> */}
                <ul className="details__info-inner-list">
                  {(() => {
                    if (
                      selectedChat.protocolo !== null &&
                      selectedChat.protocolo !== undefined &&
                      selectedChat.protocolo !== ""
                    ) {
                      return (
                        <li className="details__info-inner-item">
                          <span className="details__info-inner-label">
                            {"Protocolo : "}
                          </span>
                          <span
                            className="details__info-inner-text"
                            onClick={(e) => {
                              const isCopied = handleCopy(
                                selectedChat.protocolo
                              );
                              if (isCopied) {
                                showCopyFeedback(e.clientX, e.clientY);
                              }
                            }}
                          >
                            {selectedChat.protocolo}
                          </span>
                        </li>
                      );
                    }
                  })()}

                  {(() => {
                    if (
                      selectedChat.datatachado != undefined &&
                      selectedChat.datatachado !== "" &&
                      selectedChat.datatachado !== null
                    ) {
                      if (isJson(selectedChat.datatachado) === true) {
                        let strDtch = selectedChat.datatachado;
                        return Object.keys(strDtch).map((key) => (
                          <li className="details__info-inner-item">
                            <span className="details__info-inner-label">
                              <b>{key + ":"}</b>
                            </span>
                            <span
                              className="details__info-inner-text"
                              onClick={(e) => {
                                const isCopied = handleCopy(strDtch[key]);
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {strDtch[key]}
                            </span>
                          </li>
                        ));
                      }
                    }
                  })()}
                  {MenuBotInformations.map((bot, index) => {
                    const separator = bot.split(":");
                    const description = getDescription(separator);

                    if (separator[0]) {
                      return (
                        <li key={index} className="details__info-inner-item">
                          <span className="details__info-inner-label">
                            {`${createJSON(separator[0])}: `}
                          </span>
                          {description ? (
                            description.length > 21 ? (
                              <Tooltippy
                                content={
                                  description.length > 21
                                    ? createJSON(description)
                                    : ""
                                }
                              >
                                <span
                                  className="details__info-inner-text"
                                  onClick={(e) => {
                                    const isCopied = handleCopy(
                                      createJSON(description)
                                    );
                                    if (isCopied) {
                                      showCopyFeedback(e.clientX, e.clientY);
                                    }
                                  }}
                                >
                                  {description.length > 21
                                    ? `${createJSON(description).slice(0, 21)}
                                                      ...`
                                    : createJSON(description)}
                                </span>
                              </Tooltippy>
                            ) : (
                              <span
                                className="details__info-inner-text"
                                onClick={(e) => {
                                  const isCopied = handleCopy(
                                    createJSON(description)
                                  );
                                  if (isCopied) {
                                    showCopyFeedback(e.clientX, e.clientY);
                                  }
                                }}
                              >
                                {createJSON(description)}
                              </span>
                            )
                          ) : (
                            ""
                          )}

                          {/* <span className="details__info-inner-text">12345</span> */}
                        </li>
                      );
                    }
                  })}

                  {(() => {
                    if (
                      connection_platform.nc2_integration === true &&
                      connection_platform.nc2_users.indexOf(InfoUsers.ramal) !==
                        -1
                    ) {
                      if (
                        InfoUsers.infoclinc2.length !== 0 &&
                        selectedChat.isDialNc2
                      ) {
                        return InfoUsers.infoclinc2.map((info) => (
                          <li className="details__info-inner-item">
                            {/* <span className="details__info-icon material-icons">contact_support</span> */}
                            <span className="details__info-inner-label">
                              {info}
                            </span>
                            {/* <a href={InfoUsers.infoclinc2} title={InfoUsers.infoclinc2}><span className="details__info-text">clique para abrir</span></a> */}
                          </li>
                        ));
                      }
                    }
                  })()}
                </ul>
              </li>
              {/* )} */}
            </li>
          </ul>
          {/* <ul className="details__info-list">
            {selectedChat.idmidia !== "3" && (
              <li className="details__info-item">
                <Typography.H4 weight={700} color={"black"}>
                  Telefone:
                </Typography.H4>
                <Typography.H4 weight={400} color={"black"}>
                  {selectedChat.telefone}
                </Typography.H4>
              </li>
            )}
            <li className="details__info-item">
              <Typography.H4 weight={700} color={"black"}>
                Data do contato:{" "}
              </Typography.H4>

              <Typography.H4 weight={400} color={"black"}>
                {selectedChat.datatimeatd}
              </Typography.H4>
            </li>
            <li className="details__info-item">
              <Typography.H4 weight={700} color={"black"}>
                Motivo:
              </Typography.H4>

              <Typography.H4 weight={400} color={"black"}>
                {parseInt(selectedChat.direction) === 1
                  ? selectedChat.nomesubservico
                  : selectedChat.servico}
              </Typography.H4>
            </li>
            <br />
            <br />
            <li className="details__info-item">
              <Typography.H4 weight={700} color={"black"}>
                Informações
              </Typography.H4>

              <ul className="details__info-inner-list">
                {(() => {
                  if (
                    selectedChat.protocolo !== null &&
                    selectedChat.protocolo !== undefined &&
                    selectedChat.protocolo !== ""
                  ) {
                    return (
                      <li className="details__info-inner-item">
                        <Typography.H4 weight={700} color={"black"}>
                          {"Protocolo : "}
                        </Typography.H4>

                        <Typography.H4 weight={400} color={"black"}>
                          {selectedChat.protocolo}
                        </Typography.H4>
                      </li>
                    );
                  }
                })()}

                {(() => {
                  if (
                    selectedChat.datatachado != undefined &&
                    selectedChat.datatachado !== "" &&
                    selectedChat.datatachado !== null
                  ) {
                    if (isJson(selectedChat.datatachado) === true) {
                      let strDtch = selectedChat.datatachado;
                      return Object.keys(strDtch).map((key) => (
                        <li className="details__info-inner-item">
                          <Typography.H4 weight={700} color={"black"}>
                            {key + ":"}
                          </Typography.H4>

                          <Typography.H4 weight={400} color={"black"}>
                            {strDtch[key]}
                          </Typography.H4>
                        </li>
                      ));
                    }
                  }
                })()}
                {selectedChat.menubot.split("~¿").map((bot, index) => {
                  const separator = bot.split(":");

                  if (separator[0]) {
                    return (
                      <li key={index} className="details__info-inner-item">
                        <Typography.H4 weight={700} color={"black"}>
                          {`${createJSON(separator[0])}: `}
                        </Typography.H4>
                        {separator[1] ? (
                          separator[1].length > 21 ? (
                            <Tooltippy
                              content={
                                separator[1].length > 0
                                  ? createJSON(separator[1])
                                  : ""
                              }
                            >
                              <Typography.H4 weight={400} color={"black"}>
                                {separator[1].length > 21
                                  ? `${createJSON(separator[1]).slice(0, 21)}
                                                          ...`
                                  : createJSON(separator[1])}
                              </Typography.H4>
                            </Tooltippy>
                          ) : (
                            <Tooltippy content={createJSON(separator[1])}>
                              <Typography.H4 weight={400} color={"black"}>
                                {createJSON(separator[1])}
                              </Typography.H4>
                            </Tooltippy>
                          )
                        ) : (
                          ""
                        )}
                      </li>
                    );
                  }
                })}

                {(() => {
                  if (
                    connection_platform.nc2_integration === true &&
                    connection_platform.nc2_users.indexOf(InfoUsers.ramal) !==
                      -1
                  ) {
                    if (
                      InfoUsers.infoclinc2.length !== 0 &&
                      selectedChat.isDialNc2
                    ) {
                      return InfoUsers.infoclinc2.map((info) => (
                        <li className="details__info-inner-item">
                          <Typography.H4 weight={700} color={"black"}>
                            {info}
                          </Typography.H4>
                        </li>
                      ));
                    }
                  }
                })()}
              </ul>
            </li>
          </ul> */}
        </div>
        <div
          className={`details-line ${
            detailsOptions.interactions ? "open" : ""
          }`}
          onClick={(event) => {
            if (!detailsOptions.interactions) {
              DisplayHistoric(
                event,
                selectedChat.telefone,
                selectedChat.idatendimento
              );
            }

            setDetailsOptions({
              ...detailsOptions,
              interactions: !detailsOptions.interactions,
            });

            ShowModals(
              event,
              "modal__agenda-pf__cliente__interacoes_history",
              selectedChat.telefone,
              selectedChat.idatendimento,
              selectedChat.cliente
            );
          }}
        >
          <div className="details-line__header">
            <Typography.H4 weight={700} color={"blue-selected-4"}>
              Interações
            </Typography.H4>
            <ExportSquare className={`pausa-btn__icon-svg`} />
          </div>
          {/* <div
            style={{
              display: detailsOptions.interactions ? "flex" : "none",
              flexDirection: "column",
            }}
          >
            {(() => {
              if (historyInfo && historyInfo.historyRecent.length !== 0) {
                var cliente = createJSON(selectedChat.cliente);
                var mensagem = createJSON(
                  historyInfo.historyRecent[0].messagem
                );
                var idmidia = historyInfo.historyRecent[0].idmidia;
                var data_envio =
                  historyInfo.historyRecent[0].dataenvio +
                  "-" +
                  historyInfo.historyRecent[0].horaenvio;
                var agente = historyInfo.historyRecent[0].agente;
                let textFormatted = unicodeToChar(mensagem);
                textFormatted = tratarUnderline(textFormatted);
                return (
                  <div>
                    <div className="msg-fav__mp-bubble recent">
                      <div
                        className=" msg-fav__mp-bubble--recent"
                        style={{ pointerEvents: "none" }}
                      >
                        {ReactHtmlParser(`<p>${textFormatted}</p>`)}
                      </div>
                    </div>
                    <div className="anotc__mp-result-item-top padding">
                      <div className="anotc__mp-result-item-info--recent no-padding">
                        <p className="anotc__mp-result-item-name small">
                          {cliente}
                        </p>
                        {(() => {
                          if (agente === false) {
                            return (
                              <p className="anotc__mp-result-item-title small">
                                Cliente
                              </p>
                            );
                          } else {
                            return (
                              <p className="anotc__mp-result-item-title small">
                                Atendente
                              </p>
                            );
                          }
                        })()}
                      </div>
                      <div className="anotc__mp-result-item-critic med">
                        {(() => {
                          getMediaIcon(idmidia);
                        })()}

                        {data_envio}
                      </div>
                    </div>
                  </div>
                );
              }
            })()}

            <div
              className="anotc__mp-result-btn--recent"
              onClick={(event) =>
                ShowModals(
                  event,
                  "modal__agenda-pf__cliente__interacoes_history",
                  selectedChat.telefone,
                  selectedChat.idatendimento,
                  selectedChat.cliente
                )
              }
            >
              Ver tudo
            </div>
          </div> */}
        </div>
        <div
          className={`details-line ${detailsOptions.notes ? "open" : ""}`}
          onClick={(e) => {
            if (!detailsOptions.notes) {
              buttonSearchAnotation(e, selectedChat.telefone);
            }
            setDetailsOptions({
              ...detailsOptions,
              notes: !detailsOptions.notes,
            });
            ShowModals(
              e,
              "modal__anotacoes-details",
              selectedChat.telefone,
              selectedChat.idatendimento,
              selectedChat.cliente
            );
          }}
        >
          <div className="details-line__header">
            <Typography.H4 weight={700} color={"blue-selected-4"}>
              Anotações
            </Typography.H4>
            <ExportSquare className={`pausa-btn__icon-svg`} />
          </div>
          {/* <div
            style={{
              display: detailsOptions.notes ? "flex" : "none",
              flexDirection: "column",
            }}
          >
            {(() => {
              if (
                DetailsAnotations.detailsanotations &&
                DetailsAnotations.detailsanotations.length !== 0
              ) {
                var cliente = createJSON(selectedChat.cliente);
                var nameC =
                  DetailsAnotations.detailsanotations[0].usuario_anotacao;
                var classe =
                  DetailsAnotations.detailsanotations[0].class_criticality;
                var criticidade =
                  DetailsAnotations.detailsanotations[0].desc_criticidade;
                var datahora =
                  DetailsAnotations.detailsanotations[0].data_anotacao +
                  " - " +
                  DetailsAnotations.detailsanotations[0].hora_anotacao;
                var atendente =
                  DetailsAnotations.detailsanotations[0].usuario_anotacao;
                var texto =
                  DetailsAnotations.detailsanotations[0].desc_anotacao;
                return (
                  <div>
                    <div className="anotc__mp-result-item-top padding-bottom">
                      <button className="anotc__mp-result-avatar anotc__mp-result-avatar--recent">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10.06"
                          height="11.807"
                          viewBox="0 0 10.06 11.807"
                        >
                          <g transform="translate(0 0)">
                            <ellipse
                              cx="2.775"
                              cy="2.738"
                              rx="2.775"
                              ry="2.738"
                              transform="translate(2.255)"
                              fill="#b7bec5"
                            />
                            <path
                              d="M5.03,0A5,5,0,0,0,0,4.962H10.06A5,5,0,0,0,5.03,0Z"
                              transform="translate(0 6.844)"
                              fill="#b7bec5"
                            />
                          </g>
                        </svg>
                      </button>

                      <div className="anotc__mp-result-item-info--recent">
                        <p className="anotc__mp-result-item-name">{cliente}</p>
                        <p className="anotc__mp-result-item-title">{nameC}</p>
                      </div>
                      <div className="anotc__mp-result-item-critic">
                        <span
                          className={"anotc__mp-result-item-level " + classe}
                        >
                          {criticidade}
                        </span>
                      </div>
                    </div>

                    <div className="anotc__mp-result-item-critic">
                      <span className="anotc__mp-result-item-fulltime">
                        {datahora}
                      </span>
                    </div>
                    <div className="anotc__mp-result-item-content recent">
                      {texto}
                    </div>
                  </div>
                );
              }
            })()}
            <div
              className="anotc__mp-result-btn--recent"
              onClick={(event) =>
                ShowModals(
                  event,
                  "modal__anotacoes-details",
                  selectedChat.telefone,
                  selectedChat.idatendimento,
                  selectedChat.cliente
                )
              }
            >
              Ver tudo
            </div>
          </div> */}
        </div>
        <div
          className={`details-line ${detailsOptions.favMsg ? "open" : ""}`}
          onClick={(e) => {
            if (!detailsOptions.favMsg) {
              buttonSearchMarkstar(e, selectedChat.telefone);
            }

            setDetailsOptions({
              ...detailsOptions,
              favMsg: !detailsOptions.favMsg,
            });
            ShowModals(
              e,
              "modal__mensagens-favoritas-details",
              selectedChat.telefone,
              selectedChat.idatendimento,
              selectedChat.cliente
            );
          }}
        >
          <div className="details-line__header">
            <Typography.H4 weight={700} color={"blue-selected-4"}>
              Mensagens Favoritas
            </Typography.H4>
            <ExportSquare className={`pausa-btn__icon-svg`} />
          </div>
          {/* <div
            style={{
              display: detailsOptions.favMsg ? "flex" : "none",
              flexDirection: "column",
            }}
          >
            {(() => {
              if (
                DetailsMarkstar.detailsmarkstars &&
                DetailsMarkstar.detailsmarkstars.length !== 0
              ) {
                const detailsMarkstars =
                  DetailsMarkstar.detailsmarkstars.filter((details) =>
                    [1].includes(details.mimetypeid)
                  );
                var cliente = createJSON(selectedChat.cliente);
                var mensagem = detailsMarkstars[0].mensagem;
                var idmidia = detailsMarkstars[0].idmidia;
                var data_envio =
                  detailsMarkstars[0].data_markstar +
                  "-" +
                  detailsMarkstars[0].data_markstar;
                return (
                  <div>
                    <div className="msg-fav__mp-bubble recent">
                      <div className=" msg-fav__mp-bubble--recent">
                        {mensagem}
                      </div>
                      <span className="msg-fav__mp-star material-icons">
                        star
                      </span>
                    </div>
                    <div className="anotc__mp-result-item-top padding">
                      <div className="anotc__mp-result-item-info--recent no-padding">
                        <p className="anotc__mp-result-item-name small">
                          {cliente}
                        </p>
                      </div>
                      <div className="anotc__mp-result-item-critic med">
                        {data_envio}
                      </div>
                    </div>
                  </div>
                );
              }
            })()}

            <div
              className="anotc__mp-result-btn--recent"
              onClick={(event) =>
                ShowModals(
                  event,
                  "modal__mensagens-favoritas-details",
                  selectedChat.telefone,
                  selectedChat.idatendimento,
                  selectedChat.cliente
                )
              }
            >
              Ver tudo
            </div>
          </div> */}
        </div>
        <div
          className={`details-line ${
            detailsOptions.shareArchives ? "open" : ""
          }`}
          onClick={(e) => {
            if (!detailsOptions.shareArchives) {
              buttonSearchFileCompart(e, selectedChat.telefone);
            }
            setDetailsOptions({
              ...detailsOptions,
              shareArchives: !detailsOptions.shareArchives,
            });
            ShowModals(
              e,
              "modal__arquivos-compartilhados-details",
              selectedChat.telefone,
              selectedChat.idatendimento,
              selectedChat.cliente
            );
          }}
        >
          <div className="details-line__header">
            <Typography.H4 weight={700} color={"blue-selected-4"}>
              Arquivos compartilhados
            </Typography.H4>
            <ExportSquare className={`pausa-btn__icon-svg`} />
          </div>
          {/* <div
            style={{
              display: detailsOptions.shareArchives ? "flex" : "none",
              flexDirection: "column",
            }}
          >
            {(() => {
              if (
                DetailsFileSharedIn.detailsfileshared &&
                DetailsFileSharedIn.detailsfileshared.length !== 0
              ) {
                var cliente = createJSON(selectedChat.cliente);
                var nameC =
                  DetailsFileSharedIn.detailsfileshared[0].usuario_anotacao;
                var formato = DetailsFileSharedIn.detailsfileshared[0].formato;
                var idmidia = DetailsFileSharedIn.detailsfileshared[0].idmidia;
                var data_envio =
                  DetailsFileSharedIn.detailsfileshared[0].data_envio;
                var mensagem =
                  DetailsFileSharedIn.detailsfileshared[0].mensagem;
                var tamanhourl = dbfileSize(
                  DetailsFileSharedIn.detailsfileshared[0].filesize
                );
                return (
                  <div>
                    <div className="anotc__mp-result-item-info--recent no-padding">
                      <div className="anotc__mp-result-item-info--recent__header">
                        <div className="arq-comp__t-sort">
                          <span className="arq-comp__t-sort_ft">{formato}</span>
                        </div>

                        <div className="anotc__mp-result-item-info--recent__header__title">
                          <p className="anotc__mp-result-item-name">
                            {"Arquivo em " + formato}
                          </p>
                          <p className="anotc__mp-result-item-title">
                            {tamanhourl}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="anotc__mp-result-item-info--recent__main">
                      <div className="line">
                        <p className="anotc__mp-result-item-info--recent__main__name">
                          Data:
                        </p>
                        <p className="anotc__mp-result-item-info--recent__main__value">
                          {data_envio}
                        </p>
                      </div>
                      <div className="line">
                        <p className="anotc__mp-result-item-info--recent__main__name">
                          Canal:
                          {(() => {
                            getMediaIcon(idmidia);
                          })()}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              }
            })()}

            <div
              className="anotc__mp-result-btn--recent"
              onClick={(event) =>
                ShowModals(
                  event,
                  "modal__arquivos-compartilhados-details",
                  selectedChat.telefone,
                  selectedChat.idatendimento,
                  selectedChat.cliente
                )
              }
            >
              Ver tudo
            </div>
          </div> */}
        </div>
        {Boolean(copyFeedback) && copyFeedback.visible && (
          <div
            style={{
              position: "fixed",
              left: copyFeedback.x - 170,
              top: copyFeedback.y - 70,
              transform: "translateX(-50%)",
              backgroundColor: "#FFFFFF",
              color: "#333333",
              padding: "4px 10px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "bold",
              zIndex: 10000,
              pointerEvents: "none",
              border: "1px solid #e0e0e0",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
              animation: "fadeInUp 0.3s ease-out",
            }}
          >
            Copiado
          </div>
        )}
      </div>
    )
  );
};

export default SideDetails;
